export const EARLY_TENURE_BUSINESS_ONECMS_IMAGE_PATH = 'Internet/travel/travel-profile/early-tenure-business-tile.jpg';
export const EARLY_TENURE_CONSUMER_ONECMS_IMAGE_PATH = 'Internet/travel/travel-profile/early-tenure-consumer-tile.jpg';
export const EARLY_TENURE_CONSUMER_PLAT_URL_REDIRECT = 'travel/cardmember-travel-benefits/#platinum';
export const EARLY_TENURE_BUSINESS_PLAT_URL_REDIRECT = 'travel/cardmember-travel-benefits/#businessplatinum';
export const EARLY_TENURE_CONSUMER_GOLD_URL_REDIRECT = 'travel/cardmember-travel-benefits/#gold';
export const EARLY_TENURE_BUSINESS_GOLD_URL_REDIRECT = 'travel/cardmember-travel-benefits/#businessgold';
export const EARLY_TENURE_CARD_GROUPS = ['BP', 'BG', 'CP', 'CG'];
export const EARLY_TENURE_SEGMENT_GROUPS = ['PET', 'GET'];
export const GET_INSPIRED_IMAGE_BASE_PATH = 'https://www.americanexpress.com/en-us/travel/discover/photos';
export const GET_INSPIRED_IMAGE_SIZE = 315;
export const ENC_HIPED = 'ENC_HIPED';
